import { render, staticRenderFns } from "./dniSelect.vue?vue&type=template&id=08c852e6&"
import script from "./dniSelect.vue?vue&type=script&lang=js&"
export * from "./dniSelect.vue?vue&type=script&lang=js&"
import style0 from "./dniSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports